import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailsButtonComponent } from './details-button.component';
import { ThrottleClickDirectiveModule } from '@lib/directives';

@NgModule({
  declarations: [DetailsButtonComponent],
  imports: [CommonModule, ThrottleClickDirectiveModule],
  exports: [DetailsButtonComponent],
})
export class DetailsButtonModule {}
